import { render, staticRenderFns } from "./AddContract.vue?vue&type=template&id=5bc21f9c&scoped=true&"
import script from "./AddContract.vue?vue&type=script&lang=js&"
export * from "./AddContract.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc21f9c",
  null
  
)

export default component.exports